module.exports = __webpack_public_path__ + "static/media/aviation-icon.8f7596f4.svg";